module.exports = __webpack_public_path__ + "static/media/dai.7fa8a4ff.png";